<template>
  <div>
    <!-- 统计卡片 -->
    <el-row :gutter="16" class="stat-row">
      <el-col :span="8" v-for="(item, idx) in statCards" :key="idx">
        <div class="stat-card" :style="{ background: item.bg }">
          <div class="stat-icon"><i :class="item.icon"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ item.value }}</div>
            <div class="stat-label">{{ item.label }}</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="16">
      <el-col :span="8">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header">
              <span><i class="el-icon-data-line"></i> 进度状态 ({{ progressList.length }})</span>
              <el-select v-model="progressStatus" placeholder="全部状态" clearable size="mini" style="width:110px" @change="loadProgress">
                <el-option label="审核中" :value="0"></el-option>
                <el-option label="待签字" :value="1"></el-option>
                <el-option label="已驳回" :value="2"></el-option>
                <el-option label="已完结" :value="3"></el-option>
                <el-option label="未完结" :value="4"></el-option>
                <el-option label="已撤销" :value="6"></el-option>
              </el-select>
            </div>
          </template>
          <div v-if="!progressList.length" class="empty-tip"><p>暂无进度</p></div>
          <el-table v-else :data="progressList.slice(0, 10)" size="small" max-height="400" style="width:100%">
            <el-table-column prop="customerName" label="客户" width="90" show-overflow-tooltip></el-table-column>
            <el-table-column prop="content" label="内容" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column label="状态" width="120" align="center">
              <template slot-scope="s"><el-tag size="mini" :type="progStatusTag(s.row.rawStatus)">{{ s.row.statusText }}</el-tag></template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header">
              <span><i class="el-icon-bell"></i> 待办任务 ({{ userTaskList.length }})</span>
              <el-link type="primary" :underline="false" @click="$router.push('/user-task')">查看全部 <i class="el-icon-arrow-right"></i></el-link>
            </div>
          </template>
          <div v-if="!userTaskList.length" class="empty-tip"><p>暂无待办</p></div>
          <el-table v-else :data="userTaskList.slice(0, 10)" size="small" max-height="400" style="width:100%">
            <el-table-column prop="title" label="标题" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="content" label="内容" min-width="200" show-overflow-tooltip></el-table-column>
            <el-table-column label="优先级" width="80" align="center">
              <template slot-scope="s">
                <el-tag size="mini" :type="priorityType(s.row.priority)">{{ s.row.priority || '低' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="时间" width="100">
              <template slot-scope="s">{{ s.row.createTime ? String(s.row.createTime).slice(0,10) : '-' }}</template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header">
              <span><i class="el-icon-warning-outline"></i> 提示信息 ({{ customerAlertList.length }})</span>
              <el-link type="primary" :underline="false" @click="$router.push('/customer-alert')">查看全部 <i class="el-icon-arrow-right"></i></el-link>
            </div>
          </template>
          <div v-if="!customerAlertList.length" class="empty-tip"><p>暂无提示</p></div>
          <el-table v-else :data="customerAlertList.slice(0, 10)" size="small" max-height="400" style="width:100%">
            <el-table-column prop="customerName" label="客户" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="alertType" label="提示类型" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="级别" width="70" align="center">
              <template slot-scope="s">
                <el-tag size="mini" :type="levelType(s.row.alertLevel)">{{ s.row.alertLevel || '低' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="content" label="内容" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="时间" width="100">
              <template slot-scope="s">{{ s.row.alertTime ? String(s.row.alertTime).slice(0,10) : (s.row.createTime ? String(s.row.createTime).slice(0,10) : '-') }}</template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <!-- 旧版待办/提示面板已被上方接口对齐版替代 -->
    <el-row v-if="false" :gutter="16">
      <el-col :span="12">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header">
              <span><i class="el-icon-bell"></i> 待办任务（旧）</span>
            </div>
          </template>
          <el-tabs v-model="taskTab" class="alert-tabs">
            <el-tab-pane :label="'未审批 (' + ((tasks.pendingApplications || []).length) + ')'" name="pending">
              <div v-if="!tasks.pendingApplications || tasks.pendingApplications.length === 0" class="empty-tip"><p>暂无未审批申请</p></div>
              <el-table v-else :data="tasks.pendingApplications" size="small" max-height="380">
                <el-table-column label="客户" width="90" show-overflow-tooltip align="left" header-align="left">
                  <template slot-scope="{ row }">
                    <el-link v-if="row.customerName" type="primary" :underline="false" @click="goCustomer(row)">{{ row.customerName }}</el-link>
                    <span v-else class="muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="90">
                  <template slot-scope="{ row }">
                    <el-tag size="mini" :type="row.outboundType === '礼品' ? 'warning' : 'info'">{{ outTypeLabel(row) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="产品" min-width="90" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ row.productNames || '—' }}</template>
                </el-table-column>
                <el-table-column label="数量" width="60" align="center">
                  <template slot-scope="{ row }">{{ row.totalQuantity || 0 }}</template>
                </el-table-column>
                <el-table-column label="时间" width="100">
                  <template slot-scope="{ row }">{{ String(row.createTime || '').replace('T',' ').slice(0,10) }}</template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="'未签字 (' + ((tasks.pendingSignApplications || []).length) + ')'" name="sign">
              <div v-if="!tasks.pendingSignApplications || tasks.pendingSignApplications.length === 0" class="empty-tip"><p>暂无未签字申请</p></div>
              <el-table v-else :data="tasks.pendingSignApplications" size="small" max-height="380">
                <el-table-column label="客户" width="90" show-overflow-tooltip align="left" header-align="left">
                  <template slot-scope="{ row }">
                    <el-link v-if="row.customerName" type="primary" :underline="false" @click="goCustomer(row)">{{ row.customerName }}</el-link>
                    <span v-else class="muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="90">
                  <template slot-scope="{ row }">
                    <el-tag size="mini" type="primary">{{ outTypeLabel(row) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="产品" min-width="90" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ row.productNames || '—' }}</template>
                </el-table-column>
                <el-table-column label="数量" width="60" align="center">
                  <template slot-scope="{ row }">{{ row.totalQuantity || 0 }}</template>
                </el-table-column>
                <el-table-column label="时间" width="100">
                  <template slot-scope="{ row }">{{ String(row.createTime || '').replace('T',' ').slice(0,10) }}</template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="'未完结 (' + ((tasks.unfinishedApplications || []).length) + ')'" name="unfinished">
              <div v-if="!tasks.unfinishedApplications || tasks.unfinishedApplications.length === 0" class="empty-tip"><p>暂无未完结订单</p></div>
              <el-table v-else :data="tasks.unfinishedApplications" size="small" max-height="380">
                <el-table-column label="客户" width="90" show-overflow-tooltip align="left" header-align="left">
                  <template slot-scope="{ row }">
                    <el-link v-if="row.customerName" type="primary" :underline="false" @click="goCustomer(row)">{{ row.customerName }}</el-link>
                    <span v-else class="muted">-</span>
                  </template>
                </el-table-column>
                <el-table-column label="类型" width="90">
                  <template slot-scope="{ row }">
                    <el-tag size="mini" type="danger">{{ outTypeLabel(row) }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="产品" min-width="90" show-overflow-tooltip>
                  <template slot-scope="{ row }">{{ row.productNames || '—' }}</template>
                </el-table-column>
                <el-table-column label="数量" width="60" align="center">
                  <template slot-scope="{ row }">{{ row.totalQuantity || 0 }}</template>
                </el-table-column>
                <el-table-column label="时间" width="100">
                  <template slot-scope="{ row }">{{ String(row.createTime || '').replace('T',' ').slice(0,10) }}</template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header">
              <span><i class="el-icon-warning-outline"></i> 提示信息</span>
            </div>
          </template>
          <el-tabs v-model="activeTab" class="alert-tabs">
            <el-tab-pane :label="'服务费到期 (' + ((alerts.serviceFeeAlerts || []).length) + ')'" name="serviceFee">
              <div v-if="!alerts.serviceFeeAlerts || alerts.serviceFeeAlerts.length === 0" class="empty-tip"><p>暂无服务费到期提示</p></div>
              <el-table v-else :data="alerts.serviceFeeAlerts" size="small" max-height="380" style="width:100%">
                <el-table-column prop="customerName" label="客户" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="category" label="卡类型" min-width="70"></el-table-column>
                <el-table-column prop="customerCategory" label="类别" min-width="70" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.customerCategory || '—' }}</template>
                </el-table-column>
                <el-table-column prop="customerLabel" label="标签" min-width="70" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.customerLabel || '—' }}</template>
                </el-table-column>
                <el-table-column prop="responsiblePerson" label="负责人" min-width="70" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.responsiblePerson || '—' }}</template>
                </el-table-column>
                <el-table-column label="无效" min-width="60" align="center">
                  <template slot-scope="s">
                    <el-tag v-if="s.row.invalidCustomer" type="danger" size="mini">无效</el-tag>
                    <span v-else class="muted">—</span>
                  </template>
                </el-table-column>
                <el-table-column prop="nextDue" label="到期日" min-width="90"></el-table-column>
                <el-table-column label="剩余天数" min-width="90">
                  <template slot-scope="s">
                    <el-tag :type="s.row.daysLeft < 0 ? 'danger' : (s.row.daysLeft < 7 ? 'warning' : 'info')" size="mini">{{ s.row.daysLeft < 0 ? ('逾期 ' + (-s.row.daysLeft) + ' 天') : (s.row.daysLeft + ' 天') }}</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="'客户休眠 (' + ((alerts.dormantCustomers || []).length) + ')'" name="dormant">
              <div v-if="!alerts.dormantCustomers || alerts.dormantCustomers.length === 0" class="empty-tip"><p>暂无休眠客户</p></div>
              <el-table v-else :data="alerts.dormantCustomers" size="small" max-height="380" style="width:100%">
                <el-table-column prop="customerName" label="客户" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="category" label="卡类型" min-width="80"></el-table-column>
                <el-table-column prop="customerCategory" label="类别" min-width="80" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.customerCategory || '—' }}</template>
                </el-table-column>
                <el-table-column prop="customerLabel" label="标签" min-width="80" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.customerLabel || '—' }}</template>
                </el-table-column>
                <el-table-column prop="responsiblePerson" label="负责人" min-width="80" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.responsiblePerson || '—' }}</template>
                </el-table-column>
                <el-table-column label="无效" min-width="60" align="center">
                  <template slot-scope="s">
                    <el-tag v-if="s.row.invalidCustomer" type="danger" size="mini">无效</el-tag>
                    <span v-else class="muted">—</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="'库存不足 (' + ((alerts.lowStockProducts || []).length) + ')'" name="lowStock">
              <div v-if="!alerts.lowStockProducts || alerts.lowStockProducts.length === 0" class="empty-tip"><p>暂无库存提示</p></div>
              <el-table v-else :data="alerts.lowStockProducts" size="small" max-height="380" style="width:100%">
                <el-table-column prop="name" label="产品名称" min-width="160"></el-table-column>
                <el-table-column prop="stock" label="库存" min-width="80">
                  <template slot-scope="scope">
                    <span style="color: #F56C6C; font-weight: bold">{{ scope.row.stock }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="stockLimit" label="库存下限" min-width="90"></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
    </el-row>

    <!-- 数据可视化：客户统计 -->
    <el-row :gutter="16">
      <el-col :span="8">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header"><span><i class="el-icon-pie-chart"></i> 客户类型分布</span></div>
          </template>
          <div ref="customerPie" class="chart-box"></div>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header"><span><i class="el-icon-data-line"></i> 近 12 月新增客户</span></div>
          </template>
          <div ref="customerLine" class="chart-box"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 数据可视化：月/季/年报表 -->
    <el-row :gutter="16">
      <el-col :span="24">
        <el-card class="page-card">
          <template slot="header">
            <div class="card-header">
              <span><i class="el-icon-document"></i> 出入库报表</span>
              <el-radio-group v-model="reportPeriod" size="mini" @change="loadReport">
                <el-radio-button label="month">月</el-radio-button>
                <el-radio-button label="quarter">季</el-radio-button>
                <el-radio-button label="year">年</el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <div ref="reportBar" class="chart-box chart-box-tall"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { dashboardApi, taskApi, alertApi } from '../api/api'
import axios from 'axios'
import * as echarts from 'echarts'

export default {
  data() {
    return {
      activeTab: 'serviceFee',
      taskTab: 'pending',
      stats: {},
      tasks: {},
      alerts: {},
      userTaskList: [],
      customerAlertList: [],
      progressList: [],
      progressStatus: '',
      reportPeriod: 'month',
      _customerPie: null,
      _customerLine: null,
      _reportBar: null,
      _resizeHandler: null
    }
  },
  computed: {
    statCards() {
      return [
        { label: '产品总数', value: this.stats.productCount || 0, icon: 'el-icon-s-grid', bg: 'linear-gradient(135deg, #0D47A1 0%, #1976D2 100%)' },
        { label: '客户总数', value: this.stats.customerCount || 0, icon: 'el-icon-s-custom', bg: 'linear-gradient(135deg, #2793FF 0%, #42A5F5 100%)' },
        { label: '待审批申请', value: this.stats.pendingApplicationCount || 0, icon: 'el-icon-s-claim', bg: 'linear-gradient(135deg, #1976D2 0%, #64B5F6 100%)' }
      ]
    }
  },
  mounted() {
    this.getStats()
    this.loadProgress()
    this.loadUserTasks()
    this.loadCustomerAlerts()
    this.$nextTick(() => {
      this.initCharts()
      this.loadCustomerStats()
      this.loadReport()
    })
    this._resizeHandler = () => this.resizeCharts()
    window.addEventListener('resize', this._resizeHandler)
  },
  beforeDestroy() {
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler)
    ;[this._customerPie, this._customerLine, this._reportBar].forEach(c => c && c.dispose())
  },
  methods: {
    // 行政管理员时带 mineForUserId 让后端过滤；超管 / 业务员等都传 undefined
    _mineId() {
      const me = JSON.parse(sessionStorage.getItem('user') || '{}')
      const isSuper = me && (me.role === 'super_admin' || Number(me.roleId) === 1)
      const isAdmin = me && !isSuper && (me.role === 'admin' || Number(me.roleId) === 2)
      return (isAdmin && me.id) ? me.id : undefined
    },
    getStats() {
      axios.get('/dashboard/stats', { params: { mineForUserId: this._mineId() } }).then(res => { this.stats = res.data || {} })
    },
    // 进度状态：与业务员小程序首页"进度通知"同源。超级管理员看全部客户申请；其它账号只看自己(userId)提交的
    loadProgress() {
      const me = JSON.parse(sessionStorage.getItem('user') || '{}')
      const isSuper = me && (me.role === 'super_admin' || Number(me.roleId) === 1)
      const isAdmin = me && !isSuper && (me.role === 'admin' || Number(me.roleId) === 2)
      const params = { page: 1, size: 50 }
      if (this.progressStatus !== '' && this.progressStatus !== null) params.status = this.progressStatus
      if (!isSuper) {
        if (!me || !me.id) { this.progressList = []; return }
        if (isAdmin) params.approverId = me.id  // 行政管理员：自己经办(审批)的申请
        else params.userId = me.id              // 业务员：自己提交的申请
      }
      axios.get('/outbound/page', { params }).then(res => {
        const records = (res.data && res.data.records) || []
        this.progressList = records.map(r => ({
          id: r.id,
          rawStatus: r.status,
          customerName: r.customerName || ('客户' + (r.customerId || '')),
          content: (this.outTypeLabel(r) || '出库') + '申请',
          statusText: this.progStatusText(r.outboundType, r.status)
        }))
      }).catch(() => { this.progressList = [] })
    },
    outTypeLabel(row) {
      if (!row) return '—'
      const t = row.outboundType
      if (t === '试用' || t === '产品试用') {
        return (row.applicableTypeName && String(row.applicableTypeName).trim()) ? String(row.applicableTypeName).trim() : '试用'
      }
      return t || '—'
    },
    // 与小程序 statusMeta 同口径
    progStatusText(type, s) {
      const giftTrial = ['礼品', '试用', '产品试用'].includes(type)
      const map = { 0: '审核中', 1: giftTrial ? '已通过' : '待签字', 2: '已驳回', 3: '已完结', 4: '未完结', 5: giftTrial ? '待出库' : '已签字（待出库）', 6: '已撤销', '-1': '已驳回' }
      return map[s] != null ? map[s] : '处理中'
    },
    progStatusTag(s) {
      if (s === 3) return 'success'
      if (s === 2 || s === -1) return 'danger'
      if (s === 6) return 'info'
      if (s === 4) return 'warning'
      return ''
    },
    getTasks() { dashboardApi.getTasks().then(res => { this.tasks = res.data || {} }) },
    getAlerts() { dashboardApi.getAlerts().then(res => { this.alerts = res.data || {} }) },
    // 首页"待办任务" = 个人待办列表（当前登录用户）；先隐藏「产品到货入库提醒」(systemType=restock-arrival)
    loadUserTasks() {
      const me = JSON.parse(sessionStorage.getItem('user') || '{}')
      if (!me || !me.id) { this.userTaskList = []; return }
      taskApi.getTaskPage(me.id, 1, 50).then(res => {
        const all = (res.data && res.data.records) || []
        this.userTaskList = all.filter(r => r.systemType !== 'restock-arrival')
      })
    },
    // 首页"提示信息" = 客户提示列表（按 CustomerAlert.vue 同口径过滤）
    loadCustomerAlerts() {
      const me = JSON.parse(sessionStorage.getItem('user') || '{}')
      const isSuper = me && (me.role === 'super_admin' || Number(me.roleId) === 1)
      const isAdmin = me && !isSuper && (me.role === 'admin' || Number(me.roleId) === 2)
      const isSalesman = me && me.id && !isSuper && !isAdmin
      const params = {
        mineForUserId: (isAdmin && me.id) ? me.id : undefined,
        salesmanUserId: (isSalesman && me.id) ? me.id : undefined
      }
      alertApi.getAlertPage(1, 10000, params).then(res => {
        let records = (res.data && res.data.records) || []
        if (isSuper || isAdmin) {
          records = records.filter(a => {
            const t = a.alertType || ''
            return t.indexOf('到期提醒') !== -1
                || t.indexOf('到期休眠') !== -1
                || t.indexOf('服务费到期') !== -1
          })
        } else {
          // 业务员后台：禁售有专门的"禁售名单"，客户提示里不再显示禁售（小程序不受影响）
          records = records.filter(a => (a.alertType || '').indexOf('禁售') === -1)
        }
        this.customerAlertList = records
      })
    },
    priorityType(p) {
      if (p === '高') return 'danger'
      if (p === '中') return 'warning'
      return 'info'
    },
    levelType(l) {
      if (l === '高') return 'danger'
      if (l === '中') return 'warning'
      return 'info'
    },
    goApprove(row) {
      const path = row.outboundType === '礼品' ? '/gift-inventory' : '/product-inventory'
      this.$router.push(path + '?tab=approval&approveId=' + row.id)
    },
    goCustomer(row) {
      if (!row || !row.customerId) return
      this.$router.push('/customer?customerName=' + encodeURIComponent(row.customerName || ''))
    },
    initCharts() {
      this._customerPie = echarts.init(this.$refs.customerPie)
      this._customerLine = echarts.init(this.$refs.customerLine)
      this._reportBar = echarts.init(this.$refs.reportBar)
    },
    resizeCharts() {
      [this._customerPie, this._customerLine, this._reportBar].forEach(c => c && c.resize())
    },
    loadCustomerStats() {
      axios.get('/dashboard/customer-stats', { params: { mineForUserId: this._mineId() } }).then(res => {
        const data = res.data || {}
        // 饼图
        const byType = (data.byType || []).map(x => ({ name: x.type, value: x.count }))
        this._customerPie.setOption({
          tooltip: { trigger: 'item' },
          legend: { bottom: 0, type: 'scroll' },
          series: [{
            type: 'pie', radius: ['38%', '68%'], avoidLabelOverlap: true,
            label: { formatter: '{b}: {c} ({d}%)' },
            data: byType
          }]
        })
        // 折线
        const monthly = data.monthly || []
        this._customerLine.setOption({
          tooltip: { trigger: 'axis' },
          grid: { left: 40, right: 20, top: 30, bottom: 40 },
          xAxis: { type: 'category', data: monthly.map(x => x.month), axisLabel: { rotate: 30 } },
          yAxis: { type: 'value', minInterval: 1 },
          series: [{
            type: 'line', smooth: true, areaStyle: { opacity: 0.25 },
            itemStyle: { color: '#1976D2' },
            data: monthly.map(x => x.count)
          }]
        })
      })
    },
    loadReport() {
      axios.get('/dashboard/report', { params: { period: this.reportPeriod } }).then(res => {
        const data = res.data || {}
        const buckets = data.buckets || []
        const inbound = data.inbound || []
        const byType = data.outboundByType || {}
        const outTypes = Object.keys(byType)
        const series = []
        series.push({
          name: '入库', type: 'bar', data: inbound,
          itemStyle: { color: '#67C23A' }, barGap: '20%'
        })
        const colors = ['#F56C6C', '#E6A23C', '#909399', '#67C23A', '#1976D2', '#5C6BC0', '#26A69A']
        outTypes.forEach((t, i) => {
          series.push({
            name: '出库-' + t, type: 'bar', stack: 'out',
            data: byType[t], itemStyle: { color: colors[i % colors.length] }
          })
        })
        this._reportBar.setOption({
          tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
          legend: { top: 0, type: 'scroll' },
          grid: { left: 50, right: 20, top: 40, bottom: 40 },
          xAxis: { type: 'category', data: buckets, axisLabel: { rotate: buckets.length > 8 ? 30 : 0 } },
          yAxis: { type: 'value', name: '数量' },
          series
        }, true)
      })
    }
  }
}
</script>

<style scoped>
.stat-row { margin-bottom: 16px; }
.stat-card {
  border-radius: 12px;
  padding: 24px 26px;
  display: flex;
  align-items: center;
  color: #fff;
  box-shadow: 0 6px 18px rgba(39,147,255,0.18);
  transition: transform 0.3s;
}
.stat-card:hover { transform: translateY(-3px); box-shadow: 0 10px 24px rgba(39,147,255,0.28); }
.stat-icon { font-size: 48px; opacity: 0.85; margin-right: 18px; }
.stat-info { flex: 1; }
.stat-value { font-size: 32px; font-weight: 700; line-height: 1.2; }
.stat-label { font-size: 15px; opacity: 0.9; margin-top: 6px; letter-spacing: 1px; }
.page-card { margin-bottom: 16px; }
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-header span i { margin-right: 6px; }
.empty-tip { text-align: center; padding: 30px 0; color: #909399; }
.empty-tip p { margin-top: 8px; }
.chart-box { width: 100%; height: 320px; }
.chart-box-tall { height: 380px; }
/* tab 切换防闪：固定 pane 高度 + 关掉切换动画 */
.alert-tabs >>> .el-tabs__content { min-height: 420px; overflow: hidden; }
.alert-tabs >>> .el-tab-pane { min-height: 420px; }
.alert-tabs >>> .el-tabs__nav-wrap::after { background-color: #E4E7ED; }
.alert-tabs >>> .el-tabs__active-bar { transition: none !important; }
.alert-tabs >>> .el-tabs__item { transition: color 0.15s; }
</style>
